"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Application = void 0;
const PIXI = __importStar(require("pixi.js"));
const Logger_1 = require("./lib/Logger");
const tween_js_1 = __importDefault(require("@tweenjs/tween.js"));
PIXI.settings.TARGET_FPMS = 24 / 1000;
class Application extends PIXI.Application {
    constructor(options = {}) {
        super(Object.assign({ resizeTo: window, backgroundColor: 0x000000, antialias: true }, options));
        this.$logger = new Logger_1.Logger('Application');
        window.addEventListener('resize', () => {
            this.resize();
            if (this.camera && this.camera.visible) {
                this.camera.resize(window.innerWidth, window.innerHeight);
            }
        });
        this.tickerFallback();
        this.renderer.autoDensity = true;
        this.ticker.add(() => tween_js_1.default.update(this.ticker.lastTime));
    }
    tickerFallback() {
        this.worker = new Worker('./worker.js');
        this.worker.addEventListener('message', e => {
            if (e.data === 'ticker') {
                this.ticker.update();
            }
        });
        const updateTicker = () => {
            if (document.hidden) {
                this.worker.postMessage('startTicker');
            }
            else {
                this.worker.postMessage('stopTicker');
            }
        };
        updateTicker();
        document.addEventListener('visibilitychange', updateTicker);
    }
}
exports.Application = Application;
